import { render, staticRenderFns } from "./BasicRoleInfo.vue?vue&type=template&id=1033bc3a"
import script from "./BasicRoleInfo.vue?vue&type=script&lang=js"
export * from "./BasicRoleInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicRoleInfo.vue?vue&type=style&index=0&id=1033bc3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports